export { Checkable } from "./checkable.component";
export type { ICheckboxProps, IRadioProps } from "./checkable.component";
